import { locationIdFormat } from "@redotech/redo-inventory-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const CycleCountBinSchema = z.object({
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
});
export type CycleCountBin = z.infer<typeof CycleCountBinSchema>;

/**
 * Bulk-resolves countable bins by name prefix or exact names, unlike searchBins
 * which is a small capped typeahead over any matching substring.
 */
export const resolveCycleCountBins = {
  name: "resolveCycleCountBins" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    /** Bins whose name starts with this. */
    prefix: z.string().nullish(),
    /** Bins with exactly these names, e.g. the bins a chosen rack generates. */
    names: z.array(z.string()).nullish(),
  }),
  output: z.object({
    bins: z.array(CycleCountBinSchema),
    /** More bins matched than the response carries. */
    truncated: z.boolean(),
  }),
};
